import {formatDate} from '../../util/helpers'

export const resetForm = (data) => {
  return {
    type: 'RESET_FORM',
  }
}

export const getLogs = (data, pageNo, pageSize) => ({apis, getState}) => {
  let params = ''
  for (let key in data.params) {
    if (data.params[key]) {
      if (key !== 'includeOnlySuccess') {
        let val = (key === 'dateStart' || key === 'dateEnd') ? formatDate(data.params[key], key) : data.params[key]
        params += `${params === '' ? '' : '&'}${key}=${val}`
      } else {
        if (data.params[key] === true) {
          params += `${params === '' ? '' : '&'}logType=Success`
        }
      }
    }
  }
  params += `&page=${pageNo - 1}&pageSize=${pageSize}`
  const payload = apis.eventLogs(params).map((x) => x)
  return {
    type: 'GET_LOGS',
    payload,
    data,
  }
}

export const onPageChange = (data) => {
  return {
    type: 'PAGE_CHANGE',
    data,
  }
}

export const onPageSizeChange = (data) => {
  return {
    type: 'PAGE_SIZE_CHANGE',
    data,
  }
}



// WEBPACK FOOTER //
// ./src/store/analysis/actions.js